import React, { Component } from 'react';

export default class Footer extends Component {
  render() {
    return (
      <footer>
        <span id="footer-text-wrap">
        </span>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js